// ─── RashanPro Bilingual Labels ──────────────────────────────────────────
// Every label has English + Urdu. Urdu uses Noto Nastaliq Urdu font.
// Usage: <BiLabel en={t.products.en} ur={t.products.ur} />

export const t = {
  // App
  appName: { en: 'RashanPro', ur: 'راشن پرو' },
  tagline: { en: 'Smart Store Manager', ur: 'ہوشمند دکان مینیجر' },

  // Nav
  dashboard: { en: 'Dashboard', ur: 'ڈیش بورڈ' },
  products: { en: 'Products', ur: 'مصنوعات' },
  inventory: { en: 'My Stock', ur: 'میرا اسٹاک' },
  orders: { en: 'Orders', ur: 'آرڈرز' },
  customers: { en: 'Customers', ur: 'گاہک' },
  categories: { en: 'Categories', ur: 'قسمیں' },
  settings: { en: 'Store Settings', ur: 'دکان کی ترتیبات' },
  signOut: { en: 'Sign Out', ur: 'باہر جائیں' },

  // Dashboard Stats
  totalOrders: { en: 'Total Orders', ur: 'کل آرڈرز' },
  pendingOrders: { en: 'Pending Orders', ur: 'زیر التواء' },
  totalRevenue: { en: 'Total Revenue', ur: 'کل آمدنی' },
  todayRevenue: { en: "Today's Sales", ur: 'آج کی فروخت' },
  totalProducts: { en: 'Products in Stock', ur: 'اسٹاک میں مصنوعات' },
  lowStock: { en: 'Low Stock Items', ur: 'کم اسٹاک' },
  totalCustomers: { en: 'Total Customers', ur: 'کل گاہک' },

  // Products
  addFromCatalog: { en: 'Add from Catalog', ur: 'فہرست سے شامل کریں' },
  addCustom: { en: 'Add New Product', ur: 'نئی مصنوعات' },
  searchProducts: { en: 'Search products...', ur: 'مصنوعات تلاش کریں...' },
  productName: { en: 'Product Name', ur: 'مصنوعات کا نام' },
  category: { en: 'Category', ur: 'قسم' },
  unit: { en: 'Unit', ur: 'وزن/اکائی' },
  price: { en: 'Price (PKR)', ur: 'قیمت (روپے)' },
  stock: { en: 'Stock', ur: 'اسٹاک' },
  addToMyStore: { en: 'Add to My Store', ur: 'اپنی دکان میں شامل' },
  alreadyInStore: { en: 'Already in Store', ur: 'دکان میں موجود ہے' },
  uploadImage: { en: 'Upload Photo', ur: 'تصویر اپ لوڈ کریں' },

  // Inventory
  updateStock: { en: 'Update Stock', ur: 'اسٹاک تبدیل کریں' },
  updatePrice: { en: 'Update Price', ur: 'قیمت تبدیل کریں' },
  stockLevel: { en: 'Stock Level', ur: 'اسٹاک کی مقدار' },
  inStock: { en: 'In Stock', ur: 'موجود ہے' },
  outOfStock: { en: 'Out of Stock', ur: 'ختم ہو گیا' },
  lowStockWarn: { en: 'Low Stock', ur: 'کم اسٹاک ⚠️' },

  // Orders / Status
  orderNo: { en: 'Order #', ur: 'آرڈر نمبر' },
  customer: { en: 'Customer', ur: 'گاہک' },
  address: { en: 'Address', ur: 'پتہ' },
  total: { en: 'Total', ur: 'کل' },
  date: { en: 'Date', ur: 'تاریخ' },
  status: { en: 'Status', ur: 'حالت' },
  markNext: { en: 'Advance Status', ur: 'اگلی حالت' },
  shareWhatsApp: { en: 'Share on WhatsApp', ur: 'واٹس ایپ پر بھیجیں' },
  printReceipt: { en: 'Print Receipt', ur: 'رسید پرنٹ کریں' },
  noOrders: { en: 'No orders yet', ur: 'ابھی کوئی آرڈر نہیں' },

  // Order Statuses (Urdu)
  statusLabels: {
    PENDING: { en: 'Pending', ur: 'انتظار میں' },
    CONFIRMED: { en: 'Confirmed', ur: 'تصدیق شدہ' },
    PREPARING: { en: 'Preparing', ur: 'تیاری جاری ہے' },
    READY: { en: 'Ready', ur: 'تیار ہے' },
    OUT_FOR_DELIVERY: { en: 'Out for Delivery', ur: 'راستے میں ہے' },
    DELIVERED: { en: 'Delivered', ur: 'پہنچا دیا' },
    CANCELLED: { en: 'Cancelled', ur: 'منسوخ' },
  },

  // Forms
  save: { en: 'Save', ur: 'محفوظ کریں' },
  cancel: { en: 'Cancel', ur: 'منسوخ کریں' },
  delete: { en: 'Delete', ur: 'حذف کریں' },
  edit: { en: 'Edit', ur: 'ترمیم کریں' },
  loading: { en: 'Loading...', ur: 'لوڈ ہو رہا ہے...' },
  noData: { en: 'No data found', ur: 'کوئی ڈیٹا نہیں' },

  // Auth
  login: { en: 'Sign In', ur: 'لاگ ان کریں' },
  email: { en: 'Email', ur: 'ای میل' },
  password: { en: 'Password', ur: 'پاس ورڈ' },
  loginBtn: { en: 'Sign In', ur: 'داخل ہوں' },
  loginFailed: { en: 'Login failed', ur: 'لاگ ان ناکام ہوا' },

  // Customers
  name: { en: 'Name', ur: 'نام' },
  phone: { en: 'Phone', ur: 'فون نمبر' },
  joined: { en: 'Joined', ur: 'شامل ہوئے' },
  searchCustomers: { en: 'Search customers...', ur: 'گاہک تلاش کریں...' },

  // POS
  pos: { en: 'New Order / POS', ur: 'نیا آرڈر' },
  cart: { en: 'Cart', ur: 'ٹوکری' },
  newOrder: { en: 'New Order', ur: 'نیا آرڈر' },

  // Store settings
  storeName: { en: 'Store Name', ur: 'دکان کا نام' },
  storeCity: { en: 'City', ur: 'شہر' },
  storeAddress: { en: 'Address', ur: 'پتہ' },
  storePhone: { en: 'Phone', ur: 'فون' },
  storeEmail: { en: 'Email', ur: 'ای میل' },
};

// Helper type
export type TKey = keyof typeof t;
